module.exports = __webpack_public_path__ + "static/mentoring-project-rebound-students-6c82431c83096063fbf456e1a2954dca.jpg";